import { InputNumber } from "primereact/inputnumber";
import { Slider } from "primereact/slider";
import React, { FunctionComponentElement, useEffect, useState } from "react";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";
import { NodeInputProps } from "./index";

let reg = new RegExp(/(.*)\[(.*)\]/);
export const NumberInput = ({
  defaultValue,
  value,
  onChange,
  type,
  placeholder,
  disabled
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  

  const [args] = useState(() => {
  let m = type.match(reg);
    if (m?.[2]) {
     return m[2].split(";");
    }
    return undefined
  
  })  

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const verifyType = (value: any) => {
    return typeof value === "number";
  };

  const [valueWidget, setValueWidget] = useState(() => {
    if (value) return value;
    if (defaultValue) {
      if (verifyType(defaultValue)) return defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return undefined;
  });

  return (
    <>
      <div>
        <ErrorDefaultValueWidget displayError={incorrectDefaultValue} />

        <InputNumber
          value={valueWidget}
          mode={"decimal"}
          maxFractionDigits={20}
          onValueChange={(e) => {
            if (e.value !== null) {
              onChange(e.value);
              setIncorrectDefaultValue(false);
              setValueWidget(e.value);
            }
          }}
          placeholder={placeholder}
          disabled={disabled}
        />
        {args && (
          <Slider
            value={valueWidget}
            placeholder={placeholder}
            min={args && args.length > 0 ?  Number(args[0]) : undefined}
            max={args && args.length > 1 ?  Number(args[1]) : undefined}
            onChange={(e) => {
              // @ts-ignore
              onChange(e.value);
              setIncorrectDefaultValue(false);
              setValueWidget(e.value);
            }}
          />
        )}
      </div>
    </>
  );
};
